export default "__VITE_ASSET__DIfO4Irf__"